// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {TeachersScreenLayout} from 'app_components/screens/landing/teachers'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface ITeachersScreenProps {}
interface ITeachersScreenState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class TeachersScreen extends Component<ITeachersScreenProps, ITeachersScreenState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ITeachersScreenProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <TeachersScreenLayout
        {...this.props}
      />
    )
  }
}

export default connect(mapStatesToProps)(TeachersScreen)
